import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Barbaro (manuale V1, rr. 1991-1994).
 *
 * **Eccezione del Barbaro**: 3 archetipi **origine-tematici** (Straniero /
 * Selvaggio / Nomade), NON razza-tematici. Le altre 11 classi DWR hanno 5
 * archetipi razza-tematici (Umano/Nano/Elfo/Halfling/Mezz'orco). Il Barbaro è
 * l'unica eccezione perché i suoi archetipi sono basati su origine/background,
 * non sulla razza.
 *
 * Conseguenza per `ClassDefinition.archetypes`: ognuno di questi 3 archetipi
 * ha `associatedRace: undefined`. Lo schema `ArchetypeSchema.associatedRace` è
 * opzionale proprio per questo (vedi commento in `src/schemas/archetype.ts`).
 *
 * **Nessun archetipo del Barbaro usa `baseHpOverride`** (FI-1, finora applicato
 * solo al Paladino-Nano): il manuale Barbaro non specifica bonus stat o PF
 * extra per archetipo.
 *
 * Manuale r. 1992: «In base alle tue origini *o* al tuo background (a tua
 * scelta), prendi una delle seguenti mosse».
 */

const archetipoStraniero: Move = {
  id: 'barbaro.archetipo-straniero',
  name: 'Archetipo: Straniero',
  type: 'class_special',
  classId: 'barbaro',
  trigger: "All'inizio di ogni sessione",
  description:
    'Il GM ti farà una domanda a proposito della tua terra nativa, del perché te ne sei andato, o di cosa ti sei lasciato alle spalle. Se gli rispondi, **segna un PE**.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoSelvaggio: Move = {
  id: 'barbaro.archetipo-selvaggio',
  name: 'Archetipo: Selvaggio',
  type: 'class_special',
  classId: 'barbaro',
  trigger: 'Quando la tua letalità viene sottostimata per via del tuo aspetto primitivo',
  description: 'Ottieni **+1 al prossimo tiro di *taglia e spacca***.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNomade: Move = {
  id: 'barbaro.archetipo-nomade',
  name: 'Archetipo: Nomade',
  type: 'class_special',
  classId: 'barbaro',
  trigger: 'Quando ti *accampi* nelle terre selvagge',
  description: 'Non hai bisogno di consumare una *razione*.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const barbaroArchetypeMoves: readonly Move[] = [
  archetipoStraniero,
  archetipoSelvaggio,
  archetipoNomade,
] as const;
